import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import { TAKEWIDGET_PROPERTY_ID, TAKEWIDGET_PAGE_ID } from './lib/config';
import './App.css'
import './css/button.css';
import './css/comman.css';
import './css/toggle.css';
import Home from './container/homes/home';
import Template from './container/tamplate/index.jsx';
import Application from './container/application';
import About from './container/staticPage/about';
import ContactUs from './container/staticPage/ContactUs';
import PrivacyPolicy from './container/staticPage/privacyPolicy';
// import ScrollToTop from './container/dem2';
import FullScreenView from './container/FullScreenView';
import Footer from './components/Footer/Footer';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import BlogPage from './container/blog/BlogPage';
import BlogPost from './container/blog/BlogPost';
import TawkWidget from './components/chat/TawkWidget';
import CookieConsent from './components/CookieConsent/CookieConsent';
import Header from './components/Header/Header';
import FullScreenAd from './components/FullScreenAd/FullScreenAd';
import ShareModal from './components/ShareModal/ShareModal';
import InstallPrompt from './components/InstallPrompt/InstallPrompt';

function App() {
  const [color, setColor] = useState('#FFFF00');
  const [name, setName] = useState('');
  const [speed, setSpeed] = useState(30);
  const [isFlipText, setIsFlipText] = useState(false);
  const [blinkSpeend, setBlinkSpeend] = useState(30);
  const [fontSize, setfontSize] = useState(85);
  const [isblink, setIsblink] = useState(true);
  const [bgColor, setbgColor] = useState('#000000');
  const [RGB, setRGB] = useState({
    r: 92,
    g: 102,
    b: 122
  });
  const [isGeneratingVideo, setIsGeneratingVideo] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const [showFullScreenAd, setShowFullScreenAd] = useState(false);
  const [pendingVideoGeneration, setPendingVideoGeneration] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  // Load text from URL query parameter on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const textParam = urlParams.get('text');
    if (textParam) {
      const decodedText = decodeURIComponent(textParam);
      setName(decodedText);
    }
  }, []);

  const callVibrate = () => {
    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
    if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  }

  const handlBgcolor = (color) => {
    setbgColor(color);
    const r = parseInt(color.substr(1, 2), 16)
    const g = parseInt(color.substr(3, 2), 16)
    const b = parseInt(color.substr(5, 2), 16)
    setRGB({
      r: r,
      g: g,
      b: b
    });
  }

  const handleSpeedChanger = (val) => {
    setSpeed(val);
  };

  const handleBlinkSpeedChanger = (val) => {
    setBlinkSpeend(val);
  };

  const pluseFonthandler = () => {
    if (isMobile) {
      if (fontSize < 100) {
        setfontSize(fontSize + 1);
      }
      callVibrate();
    } else {
      if (fontSize < 100) {
        setfontSize(fontSize + 1);
      }
      callVibrate();
    }
  }

  const minusFonthandler = () => {
    if (isMobile) {
      if (fontSize > 12) {
        setfontSize(fontSize - 1);
      }
      callVibrate();
    } else {
      if (fontSize > 30) {
        setfontSize(fontSize - 1);
      }
      callVibrate();
    }
  }

  const handleBlinkToggle = (e) => {
    setIsblink(!isblink);
  }

  const onCycleComplete = (data) => {
    // Handle cycle completion
  }

  const handleNavigationClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleShareUrl = () => {
    // Track Share button click
    if (window.gtag && window.cookieConsentGiven) {
      window.gtag('event', 'share_button_click', {
        event_category: 'User Engagement',
        event_label: 'Share Button Clicked',
        value: 1
      });
    }

    // Open share modal instead of native share
    setShowShareModal(true);
    callVibrate();
  };

  const handleSaveAsVideo = async () => {
    // Check if text is empty
    if (!name || name.trim().length === 0) {
      alert('Please enter some text first.');
      return;
    }

    const textLength = name.length;
    
    // Track Download Video button click
    if (window.gtag && window.cookieConsentGiven) {
      window.gtag('event', 'download_video_click', {
        event_category: 'Video Generation',
        event_label: 'Download Video Button Clicked',
        text_length: textLength,
        value: 1
      });
    }

    // Check for long text and show warning
    if (textLength > 120) {
      const confirmProceed = window.confirm(
        `Your text is ${textLength} characters long. Generating video for long text may take longer to process and use more memory. Do you want to continue?`
      );
      if (!confirmProceed) {
        if (window.gtag && window.cookieConsentGiven) {
          window.gtag('event', 'video_generation_cancelled', {
            event_category: 'Video Generation',
            event_label: 'User Cancelled Long Text Video',
            text_length: textLength,
            value: 1
          });
        }
        return;
      }
    }

    // Show full-screen ad first
    setPendingVideoGeneration(true);
    setShowFullScreenAd(true);
  };

  // Handle when ad is closed - proceed with video generation
  const handleAdClosed = async () => {
    // Proceed with video generation after ad is closed
    await generateVideo();
    setPendingVideoGeneration(false);
  };

  // Extract video generation to separate function
  const generateVideo = async () => {
    try {
      setIsGeneratingVideo(true);
      setVideoProgress(0);
      
      // Import the video generator functions
      const { generateMarqueeVideo, downloadBlob } = await import('./utils/videoGenerator');
      
      // Find the marquee container element
      const marqueeElement = document.querySelector('.outerBox');
      
      if (!marqueeElement) {
        alert('Marquee element not found. Please ensure the text is displayed.');
        setIsGeneratingVideo(false);
        return;
      }

      // Check MediaRecorder support
      if (!window.MediaRecorder) {
        alert('Video recording is not supported in your browser. Please use a modern browser like Chrome, Firefox, or Edge.');
        setIsGeneratingVideo(false);
        return;
      }

      // Generate the video
      const videoBlob = await generateMarqueeVideo(
        marqueeElement,
        {
          text: name,
          color: color,
          bgColor: bgColor,
          speed: speed,
          fontSize: fontSize,
          isblink: isblink,
          blinkSpeed: blinkSpeend,
          isFlipText: isFlipText,
          direction: 'left'
        },
        (progress) => {
          setVideoProgress(progress);
        }
      );

      // Determine file extension based on blob type
      const mimeType = videoBlob.type;
      const extension = mimeType.includes('mp4') ? 'mp4' : 'webm';
      
      // Download the video
      const filename = `led-scroller-${name.replace(/\s+/g, '-').toLowerCase() || 'animation'}-${Date.now()}.${extension}`;
      downloadBlob(videoBlob, filename);
      
      // Track successful video download only if consent is given
      if (window.gtag && window.cookieConsentGiven) {
        window.gtag('event', 'video_download_success', {
          event_category: 'Video Generation',
          event_label: 'Video Successfully Downloaded',
          text_length: name.length,
          video_format: extension,
          value: 1
        });
      }
      
      setIsGeneratingVideo(false);
      setVideoProgress(0);
      callVibrate();
    } catch (error) {
      console.error('Error generating video:', error);
      
      // Track error with Google Analytics only if consent is given
      if (window.gtag && window.cookieConsentGiven) {
        window.gtag('event', 'video_generation_error', {
          event_category: 'Video Generation',
          event_label: error.message || 'Unknown error',
          value: 1
        });
      }
      
      alert('Failed to generate video. Please try again. Error: ' + error.message);
      setIsGeneratingVideo(false);
      setVideoProgress(0);
    }
  };

  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>LED Scroller - LED Banner | Scrolling Text Generator | Digital Signage Online</title>
          <meta name="description" content="Create free scrolling LED banners and digital signage online. LED Scroller, LED Banner, programmable LED sign, scrolling text generator, digital display board, outdoor and indoor LED signs for business, events, and advertising." />
          <meta name="keywords" content="LED Scroller, LED Banner, scrolling text, digital signage, programmable LED sign, LED display board, scrolling LED sign, digital menu board, outdoor LED sign, indoor LED sign, custom LED sign, free LED text generator, LED message board, digital advertising, electronic sign, running text, LED sign software, cloud-based digital signage, digital display, LED sign for business, LED sign for events, LED sign for shop, multilingual LED sign" />
          <link rel="alternate" href="https://ledscroller.com/" hreflang="en" />
        </Helmet>
        <Routes>
          <Route path="/fullscreen-view" element={
            <FullScreenView
              fontSize={fontSize}
              name={name}
              isMobile={isMobile}
              speed={speed}
              RGB={RGB}
              isblink={isblink}
              blinkSpeend={blinkSpeend}
              isFlipText={isFlipText}
              bgColor={bgColor}
              setName={setName}
              color={color}
              finalResult={{
                name,
                color,
                bgColor,
                speed,
                r: RGB.r,
                g: RGB.g,
                b: RGB.b
              }}
            />
          } />
          <Route path="/*" element={
            <>
              <Header onNavigationClick={handleNavigationClick} />
              
              <Routes>
                <Route path="/" element={
                  <Home
                    onCycleComplete={onCycleComplete}
                    RGB={RGB}
                    isblink={isblink}
                    speed={speed}
                    setIsFlipText={setIsFlipText}
                    isFlipText={isFlipText}
                    name={name}
                    setName={setName}
                    handleBlinkToggle={handleBlinkToggle}
                    minusFonthandler={minusFonthandler}
                    fontSize={fontSize}
                    pluseFonthandler={pluseFonthandler}
                    color={color}
                    blinkSpeend={blinkSpeend}
                    setColor={setColor}
                    bgColor={bgColor}
                    handlBgcolor={handlBgcolor}
                    handleShareUrl={handleShareUrl}
                    handleSpeedChanger={handleSpeedChanger}
                    handleBlinkSpeedChanger={handleBlinkSpeedChanger}
                    handleSaveAsVideo={handleSaveAsVideo}
                    isGeneratingVideo={isGeneratingVideo}
                    videoProgress={videoProgress}
                  />
                } />
                <Route path="/template" element={<Template />} />
                <Route path="/application" element={<Application />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route path="/fullscreen" element={<FullScreenView />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </div>
      <div className='tawk-widget-container'>
        <TawkWidget propertyId={TAKEWIDGET_PROPERTY_ID} pageId={TAKEWIDGET_PAGE_ID} />
      </div>
      <CookieConsent />
      {/* Full Screen Ad - Shows before video generation */}
      <FullScreenAd
        isOpen={showFullScreenAd}
        onClose={() => {
          setShowFullScreenAd(false);
          if (pendingVideoGeneration) {
            handleAdClosed();
          } else {
            setPendingVideoGeneration(false);
          }
        }}
      />
      {/* Share Modal */}
      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        shareText={name}
      />
      {/* PWA Install Prompt - Only shows on mobile/tablet */}
      {/* <InstallPrompt /> */}
    </Router>
  );
}

export default App;
